import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, Row, Col, Button } from "react-bootstrap";
import { login } from "../../services/LoginService";
import axios from 'axios';

export default function Login({setUser}) {

    /*
    https://dev.to/tigawanna/auth-guarding-in-react-392o
    */

    const navigate = useNavigate();

    const [error, setError] = useState('');

    let emptyLogin = {
        usuario: '',
        contrasenia: ''
    }

    const {register, formState: {errors}, handleSubmit} = useForm({
        defaultValues: {
            ...emptyLogin
        }
    });

    function beforeSubmit() {
        setError("");
    }

    const submit = async (data, e) => {
        console.log(data);
        //const response = await dispatch(login(data)).unwrap();
        const response = await login(data);
        if (response.error) {
            setError("Credenciales inválidas");
        } else {
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.jwt}`;
            setUser({login:true, ...response.data});
            console.log({login:true, ...response.data});
            navigate("/");
        }

    }

    return (
        <form onSubmit={handleSubmit(submit)}>
            <fieldset>
                <legend>Login de Usuario</legend>
                <div className="row error">
                    {error?<p>{error}</p>:''}
                </div>
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                        Usuario
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control 
                            id="usuario" 
                            {...register("usuario", {required:true})} 
                            type="text" />
                    </Col>
                    {errors.usuario?.type === 'required' && <Col className="validacion error"><p role="alert">Usuario es requerido.</p></Col>}
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="2">
                        Clave
                    </Form.Label>
                    <Col sm="9">
                        <Form.Control 
                            id="password" 
                            {...register("password", {required:true})} 
                            type="password" />
                    </Col>
                    {errors.password?.type === 'required' && <Col className="validacion error"><p role="alert">Clave es requerida.</p></Col>}
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                    <Col>
                        <Button onClick={beforeSubmit} type="submit">Ingresar</Button>
                    </Col>
                </Form.Group>
            </fieldset>
        </form>
    );
}